import { Fragment } from "core/components/FragmentProvider";
import HeadingView, { HeadingVariant } from "common/views/heading/Heading.view";
import { ImageView, ImageVariant } from "common/views/image/Image.view";
import Label from "core/components/label/Label";

export interface ICompanyFragmentProps {
    title : string;
    companyLogo: string | null;
}

export const Avatar: Fragment<ICompanyFragmentProps> = {
	name: "Company Logo",
	component: ({ companyLogo }) => (
		<ImageView viewKey="company.logo" variant={ImageVariant.LOGO} src={companyLogo} />
	)
};

export const Title: Fragment<ICompanyFragmentProps> = {
    name : "Company Title",
    component: ({title}) => (
        <HeadingView variant={HeadingVariant.H2} viewKey="company.title">
            <Label k="company.header.title" v="${title}" args={{title}}></Label>
        </HeadingView>
    )
};




// WEBPACK FOOTER //
// ./src/panels/client/intelrco/IntelCompanyFragments.tsx